import React from 'react';
import type {
	EditWidgetRowProps,
	WidgetDataSourceProps
} from 'App/components/hooks/integrations/externalIntegrationTypes';
import { Input, Text } from '@upsales/components';
import useTagTranslator from './useTagTranslator';

export const EditUiWidgetText = ({ row, onUpdate }: EditWidgetRowProps) => {
	const text = row.settings?.text || '';

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onUpdate({
			...row,
			settings: {
				...row.settings,
				text: e.target.value
			}
		});
	};

	return <Input value={text} onChange={handleChange} />;
};

const UiWidgetText: React.FC<WidgetDataSourceProps> = ({ row, dataSources, widgetSettings }) => {
	const icon = row.settings?.icon || '';
	const translatedText = useTagTranslator(row.settings, dataSources, widgetSettings);

	return (
		<Text className="UiWidget__text">
			{icon ? <i className={`fa ${icon}`} /> : null}
			{translatedText}
		</Text>
	);
};

export default UiWidgetText;
